<template>
  <div>
    <a-row>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <a style="font-size: 40px; font-weight: bolder; color: black">
          Result of custome tasks
        </a>
        <a-card style="width: 100%; margin-top: 20px">
          <a-row>
            <a-col :span="24">
              From this web page, users can query the results with the saved
              task code. We recommend that you fill in your work email when
              customizing a task, and we will send you an email with the code
              when the jobs are all finished. If it is not convenient for you to
              provide a working email or the task time is very short, you can
              save the task code, and then search for the results at the right
              time.
            </a-col>
          </a-row>
          <br />
          <br />
          <br />
          <a-row>
            <a-col
              :sm="{ span: 8, offset: 8 }"
              :md="{ span: 8, offset: 8 }"
              :xl="{ span: 8, offset: 8 }"
            >
              <a-input-search
                placeholder="Input your code"
                enter-button="Search"
                size="large"
                @search="onSearch"
            /></a-col>
          </a-row>
          <br />
          <br />
          <br />
          <a-row>
            <a-col
              :sm="{ span: 16, offset: 4 }"
              :md="{ span: 16, offset: 4 }"
              :xl="{ span: 16, offset: 4 }"
            >
              <vxe-table
                border
                show-overflow
                row-id="id"
                size="small"
                ref="xTable"
                :loading="loading3"
                :data="tableData3"
              >
                <vxe-column
                  field="task"
                  title="Task ID"
                  width="130px"
                  type="html"
                  :titlePrefix="{
                    icon: 'vxe-icon-question-circle-fill',
                    useHTML: true,
                    message:
                      'Click gene symbol to view the details of the perturbed gene',
                  }"
                >
                </vxe-column>
                <vxe-column field="status" title="Status" type="html">
                  <template #default="{ row }">
                    <a-icon
                      v-if="row.status === 'running'"
                      type="sync"
                      spin
                      style="color: red"
                    /><span
                      v-if="row.status === 'running'"
                      style="margin-left: 4px"
                      >Running...</span
                    >
                    <a-icon
                      v-if="row.status === 'done'"
                      type="check-circle"
                      theme="twoTone"
                      two-tone-color="#52c41a"
                    /><span
                      v-if="row.status === 'done'"
                      style="margin-left: 4px"
                      >Done!</span
                    >
                  </template>
                </vxe-column>
                <vxe-column field="date" title="Date" type="html"></vxe-column>
                <vxe-column field="download" title="Download" type="html">
                  <template #default="{ row }">
                    <a-button
                      :disabled="row.download !== 'true'"
                      type="primary"
                      shape="circle"
                      icon="download"
                      :size="size"
                    />
                  </template>
                </vxe-column>
                <template #empty>
                  <span style="color: grey"> No more record! </span>
                </template>
              </vxe-table>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
const tableData3 = [
  {
    task: "task_1",
    status: "running",
    date: "-",
    download: "false",
  },
  {
    task: "task_2",
    status: "done",
    date: "2022/12/7",
    download: "true",
  },
];
export default {
  data() {
    return {
      tableData3,
      formLayout: "horizontal",
      customStyle:
        "background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden;font-size:25px;line-height:25px",
    };
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
</style>
